import ClaimsPaginator from './ClaimsPaginator';
export default ClaimsPaginator;
